module.exports = __webpack_public_path__ + "static/img/content-6.c281337.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cebc/content-6.jpeg
// module id = l0yF
// module chunks = 0